import { SongSlider } from "./SongSlider";
import {FrontWebSongRadioModel} from "../../../generated";

import {useLastSongsKey} from "../../../queriesKeys/useLastSongsKey";
import {useQuery} from "@tanstack/react-query";

export const LastSongs = (props : {
    songs: FrontWebSongRadioModel[]
}) => {
    const { data: songs } = useQuery(useLastSongsKey());
    return <SongSlider title={"Právě hraje"} items={songs ?? props.songs ?? []} />
}